// React
import React from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import Line from './line'
import Delay from 'store/v2/react/components/delay'
import { PoweredBy } from 'shop-components/components/PoweredBy'

// Libraries
import { Motion, spring } from 'react-motion'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import clientActions from 'store/v2/redux/actions/client'
import ReactCSSTransitionGroup from 'shared/lib/react_css_transition_group'

const easing = { stiffness: 150, damping: 15 }

class Lines extends React.Component {
  static displayName = 'Lines'

  static propTypes = {
    className: PropTypes.string,
    hasDates: PropTypes.bool,
    cannotCheckout: PropTypes.bool,
    lines: PropTypes.object,
    toggleCart: PropTypes.func,
    nonServiceCartLinesCount: PropTypes.number,
    showPoweredBy: PropTypes.bool,
    t: PropTypes.func
  }

  componentWillUnmount () {
    return clientActions.setCartScroll(0)
  }

  render () {
    const { lines, hasDates, cannotCheckout, className, toggleCart, nonServiceCartLinesCount, showPoweredBy, t } = this.props

    return (
      <div id="booqable-sidebar-lines" className={className}>
        <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={100} transitionLeaveTimeout={100}>
          {hasDates && cannotCheckout && (
            <div className="bq-notice">
              <i className="bq-icon-warning fas fa-exclamation-triangle" />
              {t('user.store.not_all_products_available')}
            </div>
          )}
        </ReactCSSTransitionGroup>
        {!!nonServiceCartLinesCount && (
          <ul className="bq-list">
            <ReactCSSTransitionGroup
              transitionName="booqable-sidebar-line"
              transitionAppear={false}
              transitionEnter={false}
              transitionLeaveTimeout={300}
              component="li"
            >
              {lines.map((line, i) => (
                <Delay key={line.id} initial={0} value={1} period={i * 80}>
                  {(delayed) => (
                    <Motion key={line.id} defaultStyle={{ v: 0 }} style={{ v: spring(delayed, easing) }}>
                      {(value) => (
                        <Line
                          uiKey={line.id}
                          key={line.id}
                          line={line}
                          hasDates={hasDates}
                          style={{
                            opacity: value.v,
                            transform: window.testMode ? 'scale(1)' : `scale(${value.v})`
                          }}
                        />
                      )}
                    </Motion>
                  )}
                </Delay>
              ))}
            </ReactCSSTransitionGroup>
          </ul>
        )}
        {!nonServiceCartLinesCount && (
          <div className="bq-cleanstate">
            {t('user.store.cart_empty')}
            <button className="bq-link" onClick={toggleCart.bind(null, false)}>
              {t('user.store.continue_shopping')}
            </button>
          </div>
        )}
        {!nonServiceCartLinesCount && showPoweredBy && (
          <div className="bq-poweredby">
            <PoweredBy logoWidth="16px" />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const lines = state.orm.lines.getAll({ id: props.cart != null ? props.cart.lines : undefined })
  const nonServiceCartLinesCount = lines.pluck('product_type').filter((type) => type !== 'service').length
  const showPoweredBy = state.settings.get('store.show_powered_by')

  return {
    cartOpen: state.client.cartOpen,
    lines,
    nonServiceCartLinesCount,
    className: 'active',
    showPoweredBy
  }
}

export default compose(withTranslation('user'), reduxConnect(mapStateToProps))(Lines)
